import React from 'react';
import './FaqQuestions.css';

import {data} from './data';

function FaqQuestions() {
    const [open, setOpen] = React.useState([]);

    return (
        <section className="surveys-faq">
            <h1>FAQ</h1>
            <div className="surveys-faq-questions">
                {data?.map((question, index) =>
                    <div key={index} className="surveys-faq-question">
                        <div className="surveys-faq-question-title"
                             onClick={() => {
                                 // Find the id of the clicked question and add class open
                                 const question = document.getElementById("question-" + index);
                                 const logo = document.getElementById("question-logo-" + index);
                                 if (open.includes(index)) {
                                     setOpen(open.filter(item => item !== index));
                                     question.classList.remove("open");
                                     logo.classList.remove("down");
                                     logo.classList.add("up");
                                 } else {
                                     setOpen([...open, index]);
                                     question.classList.add("open");
                                     logo.classList.remove("up");
                                     logo.classList.add("down");
                                 }
                             }}>
                            <div id={"question-logo-" + index} className="surveys-faq-question-icon">
                                <svg xmlns="http://www.w3.org/2000/svg"
                                     width="24"
                                     height="24"
                                     viewBox="0 0 24 24"
                                     fill="none">
                                    <path
                                        d="M16.2803 11.4697C16.5732 11.7626 16.5732 12.2374 16.2803 12.5303L8.78033 20.0303C8.48744 20.3232 8.01256 20.3232 7.71967 20.0303C7.42678 19.7374 7.42678 19.2626 7.71967 18.9697L14.6893 12L7.71967 5.03033C7.42678 4.73744 7.42678 4.26256 7.71967 3.96967C8.01256 3.67678 8.48744 3.67678 8.78033 3.96967L16.2803 11.4697Z"
                                        fill="#0F172A"/>
                                </svg>
                            </div>
                            <h3>{question.title}</h3>
                        </div>
                        <div id={"question-" + index} className={`surveys-faq-question-description`}>
                            <p>{question.description}</p>
                        </div>
                    </div>
                )}
            </div>
        </section>
    );
}

export default FaqQuestions;
